export default __webpack_public_path__ + "static/media/footer-text-logo.4f8d0fc3.svg";